export default "/assets/images/slide-mini-lg.webp?edca0abb1971e41f2b854bd1bfe67236";